<template>
    <div class="new-license-key">
        <div class="license-input-modal" v-if="isKeyboardVisible" @click="onModalClicked"></div>
        <div class="car-number-container">
            <div class="car-number-box" @click="$emit('clicked')" ref="licensePlateInputBox">
                <div class="car_type">
                    <div class="default_car" :class="{active_car : activeInputIndex == 0}"
                         @click="chooseNumber(licensePlateChars[0],0)">
                        <div v-show="licensePlateChars[0]">{{ licensePlateChars[0] }}</div>
                    </div>
                    <div class="default_car default_car1" :class="{active_car: activeInputIndex == 1}"
                         @click="chooseNumber(licensePlateChars[1],1)">
                        <div v-show="licensePlateChars[1]">{{ licensePlateChars[1] }}</div>
                    </div>
                    <div class="default_dot" v-if="keyboardType == 0"></div>
                    <div class="default_car" :class="{active_car:activeInputIndex == 2}"
                         @click="chooseNumber(licensePlateChars[2],2)">
                        <div v-show="licensePlateChars[2]">{{ licensePlateChars[2] }}</div>
                    </div>
                    <div class="default_car" :class="{active_car : activeInputIndex == 3}"
                         @click="chooseNumber(licensePlateChars[3],3)">
                        <div v-show="licensePlateChars[3]">{{ licensePlateChars[3] }}</div>
                    </div>
                    <div class="default_car" :class="{active_car : activeInputIndex == 4}"
                         @click="chooseNumber(licensePlateChars[4],4)">
                        <div v-show="licensePlateChars[4]">{{ licensePlateChars[4] }}</div>
                    </div>
                    <div class="default_car" :class="{active_car : activeInputIndex == 5}"
                         @click="chooseNumber(licensePlateChars[5],5)">
                        <div v-show="licensePlateChars[5]">{{ licensePlateChars[5] }}</div>
                    </div>
                    <template v-if="keyboardType == 0" title="大陆车牌，第七位正常输入">
                        <div class="default_car" :class="{active_car : activeInputIndex == 6}"
                             @click="chooseNumber(licensePlateChars[6],6)">
                            <div v-show="licensePlateChars[6]">{{ licensePlateChars[6] }}</div>
                        </div>
                    </template>
                    <template v-else title="港澳车牌，第七位手动点击才可输入">
                        <div v-if="isLastHkmoLicensePlateInputActive || licensePlateChars.length >= 7"
                             :class="['default_car', activeInputIndex == 6 && (isLastHkmoLicensePlateInputActive || licensePlateChars.length >= 6) ? 'active_car': '']"
                             @click="chooseNumber(licensePlateChars[6],6)">
                            <div v-show="licensePlateChars[6]">{{ licensePlateChars[6] }}</div>
                        </div>
                        <div class="default_car inactive-hkmo-input"
                             v-else
                             @click="onLastHkmoLicenseInputClicked">
                            <div></div>
                        </div>
                    </template>

                    <template v-if="keyboardType == 0">
                        <div class="default_car"
                             v-if="isNewEnergyLicensePlateInputActive"
                             :class="{diabled_car:isNewEnergyLicensePlateInputActive != 1,active_car:activeInputIndex == 7 && isNewEnergyLicensePlateInputActive == 1}"
                             @click="chooseNumber(licensePlateChars[7],7)">
                            <div v-show="licensePlateChars[7]">{{ licensePlateChars[7] }}</div>
                        </div>
                        <div class="default_car diabled_car"
                             v-if="!isNewEnergyLicensePlateInputActive"
                             @click="chooseIsNewEnergy">
                            <div>新</div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <!-- 键盘 -->
        <div class="keyboard-container" v-if="isKeyboardVisible">
            <div class="keyboard-header">
                <i class="iconfont iconqiehuan"></i> <span v-if="keyboardType == 1" @click="switchKeyboardType(0)">输大陆车牌</span><span v-else @click="switchKeyboardType(1)">输港澳车牌</span>
            </div>
            <!-- 省份键盘 -->
            <div v-if="keyboardType == 0 && isProvinceKeyboardVisible" class="keyboard-panel">
                <div class="province-keyboard">
                    <div v-for="(item,index) in provinceRow1Keys" :key="index"
                         :class="['key-province', hoverMap.has(item) ? 'key-hover' : '']"
                         @click="provinceKeyClick(item,index)"
                         @mousedown="onKeyDown(item)"
                         @mouseup="onKeyUp(item)"
                         @touchstart="onKeyDown(item)"
                         @touchend="onKeyUp(item)"
                    >
                        <div class="text">
                            {{ item }}
                        </div>
                    </div>
                </div>
                <div class="province-keyboard">
                    <div v-for="(item,index) in provinceRow2Keys" :key="index"
                         :class="['key-province', hoverMap.has(item) ? 'key-hover' : '']"
                         @click="provinceKeyClick(item,index)"
                         @mousedown="onKeyDown(item)"
                         @mouseup="onKeyUp(item)"
                         @touchstart="onKeyDown(item)"
                         @touchend="onKeyUp(item)"
                    >
                        <div class="text">
                            {{ item }}
                        </div>
                    </div>
                </div>
                <div class="province-keyboard">
                    <div v-for="(item,index) in provinceRow3Keys"
                         :class="['key-province', hoverMap.has(item) ? 'key-hover' : '']"
                         :key="index" @click="provinceKeyClick(item,index)"
                         @mousedown="onKeyDown(item)"
                         @mouseup="onKeyUp(item)"
                         @touchstart="onKeyDown(item)"
                         @touchend="onKeyUp(item)"
                    >
                        <div class="text">{{ item }}</div>
                    </div>
                </div>
                <div class="province-keyboard last">
                    <div v-for="(item,index) in provinceRow4Keys" :key="index"
                         :class="['key-province', hoverMap.has(item) ? 'key-hover' : '']"
                         @click="provinceKeyClick(item,index)"
                         @mousedown="onKeyDown(item)"
                         @mouseup="onKeyUp(item)"
                         @touchstart="onKeyDown(item)"
                         @touchend="onKeyUp(item)"
                    >
                        <div class="text">{{ item }}</div>
                    </div>
                    <div @click.stop="onCleanClick"
                         :class="['key-province', 'key-clean', hoverMap.has('清空') ? 'key-hover' : '']"
                         @mousedown="onKeyDown('清空')"
                         @mouseup="onKeyUp('清空')"
                         @touchstart="onKeyDown('清空')"
                         @touchend="onKeyUp('清空')"
                    >
                        <div class="text">清空</div>
                    </div>
                    <div @click.stop="closeFn"
                         :class="['key-province', 'key-close', hoverMap.has('关闭') ? 'key-hover' : '']"
                         @mousedown="onKeyDown('关闭')"
                         @mouseup="onKeyUp('关闭')"
                         @touchstart="onKeyDown('关闭')"
                         @touchend="onKeyUp('关闭')">
                        <div class="text">关闭</div>
                    </div>
                </div>
            </div>
            <div v-if="keyboardType == 1 || !isProvinceKeyboardVisible" class="keyboard-panel">
                <!--数字键盘-->
                <div class="number-keyboard">
                    <template>
                        <div v-for="(item,index) in numberKeys" :key="index"
                             @click="onNumberKeyClicked(item,index)"
                             :class="['key', hoverMap.has(item) ? 'key-hover' : '']"
                             @mousedown="onKeyDown(item)"
                             @mouseup="onKeyUp(item)"
                             @touchstart="onKeyDown(item)"
                             @touchend="onKeyUp(item)"
                        >
                            {{ item }}
                        </div>
                    </template>
                </div>
                <!--字母键盘-->
                <div class="english-keyboard">
                    <div v-for="(item,idx) in englishRow1Keys"
                         :class="['key', hoverMap.has(item) ? 'key-hover' : '']"
                         @click="onEnglishKeyClicked(item,idx)"
                         @mousedown="onKeyDown(item)"
                         @mouseup="onKeyUp(item)"
                         @touchstart="onKeyDown(item)"
                         @touchend="onKeyUp(item)"
                    >
                        {{ item }}
                    </div>
                </div>
                <div class="english-keyboard">
                    <div v-for="(item,idx) in englishRow2Keys" :key="idx"
                         :class="['key', hoverMap.has(item) ? 'key-hover' : '']"
                         @click="onEnglishKeyClicked(item,idx)"
                         @mousedown="onKeyDown(item)"
                         @mouseup="onKeyUp(item)"
                         @touchstart="onKeyDown(item)"
                         @touchend="onKeyUp(item)"
                    >
                        {{ item }}
                    </div>
                </div>
                <div class="english-keyboard">
                    <div v-for="(item,index) in englishRow3Keys"
                         :class="['key', hoverMap.has(item) ? 'key-hover' : '']"
                         @click="onEnglishKeyClicked(item,index)"
                         @mousedown="onKeyDown(item)"
                         @mouseup="onKeyUp(item)"
                         @touchstart="onKeyDown(item)"
                         @touchend="onKeyUp(item)"
                    >
                        {{ item }}
                    </div>
                    <div @click="onDeleteClick"
                         :class="['key-grey', 'key-wide','flex', hoverMap.has('删除') ? 'key-hover' : '']"
                         @mousedown="onKeyDown('删除')"
                         @mouseup="onKeyUp('删除')"
                         @touchstart="onKeyDown('删除')"
                         @touchend="onKeyUp('删除')">删除
                    </div>
                </div>
                <!-- 最后一行 -->
                <div class="english-keyboard">
                    <div v-for="(item,index) in englishRow4Keys"
                         :class="['key', hoverMap.has(item) ? 'key-hover' : '']"
                         @click="onEnglishKeyClicked(item,index)"
                         @mousedown="onKeyDown(item)"
                         @mouseup="onKeyUp(item)"
                         @touchstart="onKeyDown(item)"
                         @touchend="onKeyUp(item)"
                    >
                        {{ item }}
                    </div>

                    <div @click.stop="closeFn"
                         :class="['key-grey', 'key-wide','flex', hoverMap.has('确认') ? 'key-hover' : '']"
                         @mousedown="onKeyDown('确认')"
                         @mouseup="onKeyUp('确认')"
                         @touchstart="onKeyDown('确认')"
                         @touchend="onKeyUp('确认')">
                        <div class="text">确认</div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
export default {
    name: "NewLicenseKey",
    props: {
        isVisible: {
            type: Boolean,
            default: false,
        },
        license: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            currentInputIndex: 0,
            licensePlateChars: [],
            isKeyboardVisible: false,
            keyboardType: 0, //0.大陆车牌 1.车牌
            carTypeList: [{
                text: '新能源',
                value: 1,
            }],
            isNewEnergyLicensePlateInputActive: 0,
            isLastHkmoLicensePlateInputActive: false,

            provinceRow1Keys: '京沪浙苏粤鲁晋豫冀',
            provinceRow2Keys: '川渝辽吉黑皖鄂津贵',
            provinceRow3Keys: '云桂琼青新藏蒙宁甘',
            provinceRow4Keys: '陕闽赣湘使领',
            isProvinceKeyboardVisible: true, // 省键盘

            numberKeys: '0123456789',
            isEnglishKeyboardEnabled: false, // 字母键盘可点击

            hoverMap: new Map(), //用于记录按钮是否处于被点击状态

            englishRow1Keys: 'QWERTYUIOP',
            englishRow2Keys: 'ASDFGHJKL',
            englishRow3Keys: 'ZXCVBNM',
            englishRow4Keys: '警学港澳挂',

            trailerFiledIsDis: true, // 挂字禁用
            activeInputIndex: 0,
            isClickCarNum: false,
            isCheckEnergy: false,
        };
    },
    created() {
    },

    mounted() {
        this.setKeyboardTypeByLicensePlate();
        if (this.keyboardType == 0 && this.license.length > 7) {
            this.isNewEnergyLicensePlateInputActive = 1;
        }
        if (this.license) {
            this.licensePlateChars = this.license.split('');
        }
    },
    methods: {
        onLastHkmoLicenseInputClicked() {
            this.isLastHkmoLicensePlateInputActive = true;
            this.isKeyboardVisible = true;
            this.currentInputIndex = 6;
            this.activeInputIndex = 6;
        },
        // 点击车牌号输入框
        chooseNumber(licensePlateChar, inputIndex) {
            if (!this.isKeyboardVisible) {
                this.isKeyboardVisible = true;
                this.$emit('update:isVisible', this.isKeyboardVisible);
                this.$refs.licensePlateInputBox.scrollIntoView({
                    behavior: 'smooth',
                    block: "center"
                })
            }

            this.setKeyboardTypeByLicensePlate();

            if (inputIndex == 1) {
                this.isProvinceKeyboardVisible = false
            }
            else if (inputIndex == '0') {
                // 第一位
                this.isProvinceKeyboardVisible = true
            }
            else {
                this.isProvinceKeyboardVisible = false
            }
            if (this.isNewEnergyLicensePlateInputActive == 0 && inputIndex == '7') {
                // 普通车牌 不让点击一位
            }
            else {
                this.activeInputIndex = inputIndex
                this.currentInputIndex = inputIndex
                this.isClickCarNum = true
            }
            if ((this.isNewEnergyLicensePlateInputActive == 0 && this.licensePlateChars.length >= 6 && this.currentInputIndex >= 6) || (this.isNewEnergyLicensePlateInputActive == 1 && this.licensePlateChars.length >= 7 && this.currentInputIndex >= 7)) {
                this.trailerFiledIsDis = false;
            }
            else {
                this.trailerFiledIsDis = true;
            }

        },
        setKeyboardTypeByLicensePlate() {
            if (this.licensePlateChars.length > 0) {
                const validProvinces = '京沪浙苏粤鲁晋豫冀川渝辽吉黑皖鄂津贵云桂琼青新藏蒙宁甘陕闽赣湘';
                // 判断第一个字是否为有效的车牌简称
                const provinceChar = this.licensePlateChars[0];
                if (validProvinces.includes(provinceChar)) {
                    this.keyboardType = 0;
                }
                else {
                    this.keyboardType = 1;
                }
            }
            else {
                this.keyboardType = 0;
            }
        },
        switchKeyboardType(nextKeyboardType) {
            this.keyboardType = nextKeyboardType;
            this.licensePlateChars = [];
            this.currentInputIndex = 0;
            this.activeInputIndex = 0;
            if (this.keyboardType == 0) {
                this.isProvinceKeyboardVisible = true;
            }
        },
        // 点击新能源或者普通车
        chooseIsNewEnergy() {
            // console.log(this.carNumber, '切换新能源')
            this.isKeyboardVisible = true;
            if (this.isNewEnergyLicensePlateInputActive == 1) {
                this.isNewEnergyLicensePlateInputActive = 0
                if (this.licensePlateChars.length == 8) {
                    this.licensePlateChars.pop()
                }
            }
            else {
                this.isNewEnergyLicensePlateInputActive = 1
                if (this.licensePlateChars.length == 7) {
                    this.currentInputIndex = 7
                    this.activeInputIndex = 7
                }
            }
            this.isProvinceKeyboardVisible = false
            // console.log(this.carNumber, '切换新能源后')
            this.$forceUpdate()
        },
        // 省份键盘
        provinceKeyClick(val, index) {
            this.$set(this.licensePlateChars, 0, val);
            this.isProvinceKeyboardVisible = false
            this.isEnglishKeyboardEnabled = false;
            this.currentInputIndex++
            this.activeInputIndex = this.currentInputIndex;
            this.completeFn();
            this.$forceUpdate()
            // console.log(this.current, 'current')
        },
        // 数字键盘
        onNumberKeyClicked(val, idx) {
            this.currentInputIndex++
            this.$set(this.licensePlateChars, this.currentInputIndex - 1, val);
            this.setTrailerKeyboardDis()
            this.$forceUpdate()
            this.activeInputIndex = this.currentInputIndex
            this.completeFn();
        },
        // 字母键盘
        onEnglishKeyClicked(val, idx) {
            if (this.isEnglishKeyboardEnabled)
                return

            this.currentInputIndex++
            this.$set(this.licensePlateChars, this.currentInputIndex - 1, val);

            this.setTrailerKeyboardDis()
            this.$forceUpdate()
            this.activeInputIndex = this.currentInputIndex
            this.completeFn();
        },

        onKeyDown(item) {
            if (!this.hoverMap.has(item)) {
                this.hoverMap.set(item, 1)
            }
            this.$forceUpdate();
        },
        onKeyUp(item) {
            this.$nextTick(()=>{
                if (this.hoverMap.has(item)) {
                    this.hoverMap.delete(item)
                }
                this.$forceUpdate();
            });
        },
        // 设置挂车键盘禁用（只能最后一个选择挂）
        setTrailerKeyboardDis() {
            if ((this.isNewEnergyLicensePlateInputActive == 0 && this.licensePlateChars.length >= 6 && this.currentInputIndex >= 6) || (this.isNewEnergyLicensePlateInputActive == 1 && this.licensePlateChars.length >= 7 && this.currentInputIndex >= 7)) {
                this.trailerFiledIsDis = false;
            }
            else {
                this.trailerFiledIsDis = true;
            }
            this.completeFn();
        },
        completeFn() {
            if (this.keyboardType == 0) {
                if ((!this.isNewEnergyLicensePlateInputActive && this.licensePlateChars.length >= 7 && this.currentInputIndex > 6)
                    || (this.isNewEnergyLicensePlateInputActive && this.licensePlateChars.length >= 8 && this.currentInputIndex > 7)) {
                    this.isKeyboardVisible = false;
                }
            }
            else {
                if ((!this.isLastHkmoLicensePlateInputActive && this.licensePlateChars.length == 6 && this.currentInputIndex == 6)
                    || this.isLastHkmoLicensePlateInputActive && this.licensePlateChars.length == 7 && this.currentInputIndex > 6) {
                    this.isKeyboardVisible = false;
                }
            }
            this.$emit('complete', this.licensePlateChars);
        },
        closeFn() {
            this.isKeyboardVisible = false;
            this.$emit('complete', this.licensePlateChars);
            this.$emit('update:isVisible', this.isKeyboardVisible);
        },

        onCleanClick() {
            if (this.licensePlateChars.length > 0) {
                this.licensePlateChars = [];
            }
            this.currentInputIndex = 0;
            this.activeInputIndex = 0;
        },
        onDeleteClick() {
            if (this.licensePlateChars.length > 0) {
                this.licensePlateChars.splice(this.licensePlateChars.length - 1, 1);
            }
            this.currentInputIndex = this.licensePlateChars.length;
            this.activeInputIndex = this.currentInputIndex;
        },
        onModalClicked() {
            this.isKeyboardVisible = false;
        }
    },
    watch: {
        licensePlateChars: {
            handler(newVal, oldValue) {
                this.$emit('licensePlateUpdated', newVal.join(''))
            },
            deep: true,
            immediate: true
        },
        license: {
            handler(newVal, oldValue) {
                if (newVal) {
                    this.licensePlateChars = newVal.split('');
                }
            },
            immediate: true
        },
        isVisible: {
            handler(newVal, oldValue) {
                this.isKeyboardVisible = newVal;
            },
            immediate: true
        },
    },
    destroyed() {
        this.isKeyboardVisible = false;
        this.$emit('update:isVisible', this.isKeyboardVisible);
    }
}
</script>

<style lang="scss" scoped>
.new-license-key {
    box-sizing: border-box;
    z-index: 999;

    .license-input-modal {
        position: fixed;
        height: 100vh;
        width: 100%;
        left: 0;
        top: 0;
    }
}


.car-number-container {
    width: 301px;
    background: #FFFFFF;
    border-radius: 6px;
    margin: 0 auto;
    font-size: 16px;
    font-family: 'PingFangSC-Regular, PingFang SC';
    font-weight: 400;
    color: #333333;
    text-align: center;
    box-sizing: border-box;

    .car-number-box {
        margin-top: 0;

        .car_type {
            display: flex;
            justify-content: space-between;
            margin: 0 auto;
            width: 100%;
            align-items: center;
        }
    }
}

.flex {
    display: flex;
}

.default_car {
    width: 32px;
    height: 42px;
    line-height: 42px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid $borderColor1;
    text-align: center;
    font-size: 20px;
    color: #333333;
}

.keyboard-container {
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #ced3d9;
    z-index: 9999;

    .keyboard-panel {
        padding: 3px 0;
    }

    .keyboard-header {
        padding: 0 8px;
        height: 32px;
        line-height: 32px;
        background: white;
    }

    .province-keyboard {
        display: flex;
        padding: 0 4px;
        justify-content: center;

        .key-province-del {
            display: flex;
            align-items: center;
            flex: 0 1 20%;
        }

    }

    .number-keyboard {
        padding: 0 4px;
        display: flex;
        justify-content: center;
        gap: 4px;
    }

    .english-keyboard {
        display: flex;
        justify-content: center;
        gap: 4px;
        padding: 0 4px;
    }

    .key {
        flex: 0 1 10%;
        font-size: 16px;
        color: #333333;
        font-weight: 500;
        box-shadow: 2px 2px 2px #888;
        border-radius: 4px;
        text-align: center;
        background-color: #fff;
        height: 34px;
        line-height: 34px;
        margin: 2px 0;
    }

    .key-province {
        color: #000;
        font-weight: 500;
        text-align: center;
        height: 34px;
        line-height: 34px;
        margin: 3px 0;
        flex: 0 1 calc(100% / 9);
        padding: 0 2px;

        .text {
            font-size: 16px;
            background-color: #fff;
            box-shadow: 2px 2px 2px #888;
            border-radius: 6px;
        }

    }

    .key-province.key-hover {
        .text {
            background-color: $theme4;
            color: white;
        }
    }

    .key-clean {
        flex: 0 1 calc(100% / 9 * 2);
        padding: 0 2px;
    }

    .key-close {
        flex: 0 1 calc(100% / 9);
        padding: 0 2px;

        .text {
            color: #fff;
            background-color: #AAADB7;
            box-shadow: 0 2px 0 0 #898A8D;
            border-radius: 6px;
        }
    }


    .key-switch-province {
        width: 72px;
        flex: 0 1 12%;
    }

    .key-grey {
        flex: 0 1 9%;
        height: 34px;
        line-height: 34px;
        text-align: center;
        border-radius: 6px;
        justify-content: center;
        align-items: center;
        color: #fff;
        background-color: #AAADB7;
        box-shadow: 2px 2px 2px #888;
        font-size: 15px;
        margin: 3px 0;

        .cls {
            font-size: 26px;
            color: #fff;
        }
    }

    .key-wide {
        flex: 0 1 12%;
    }

    .key.key-hover, .key-grey.key-hover {
        background-color: $theme4;
        color: white;
    }

}

.default_dot {
    width: 4px;
    height: 4px;
    background: #333333;
    margin: 0 2px;
}

.diabled_car {
    background: #F5F5F5;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.1);
}

.inactive-hkmo-input {
    border-radius: 4px;
    border: 1px dashed #ccc;
    background: #fff;
}

.active_car {
    border-radius: 4px;
    border: 1px solid #375DE9;
}

</style>